// Dark banner shown at the top of the tenant hub when a super-admin is
// impersonating that brand. Positioned over ONLY the right content area
// (sidebar untouched), with the text left-aligned to the hero padding
// (`px-10`) and the Exit button right-aligned to the Edit-content position
// (`right-6`) so it reads as a natural extension of the page toolbar.
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ShieldCheck, X } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

export default function GodModeBanner() {
  const navigate = useNavigate();
  const [brand, setBrand] = useState(null);

  useEffect(() => {
    const sync = () => {
      try {
        const raw = localStorage.getItem("bh_imp_brand");
        setBrand(raw ? JSON.parse(raw) : null);
      } catch { setBrand(null); }
    };
    sync();
    window.addEventListener("storage", sync);
    return () => window.removeEventListener("storage", sync);
  }, []);

  if (!brand) return null;

  const exit = async () => {
    try { await api.post("/super-admin/impersonate/exit", { brand_id: brand.id }); } catch { /* ignore */ }
    localStorage.removeItem("bh_imp_token");
    localStorage.removeItem("bh_imp_brand");
    setBrand(null);
    toast.success("God Mode beëindigd");
    navigate("/super-admin");
  };

  return (
    <div
      data-testid="god-mode-banner"
      className="sticky top-0 z-50 bg-[#1a1a1a] text-white border-b border-black/40 md:ml-[var(--bh-sidebar-w,16rem)] transition-[margin] duration-300"
    >
      <div className="px-6 md:pl-10 md:pr-6 h-10 flex items-center justify-between gap-4">
        <div className="flex items-center gap-2 text-xs">
          <ShieldCheck className="w-3.5 h-3.5 text-amber-300" strokeWidth={2} />
          <span className="font-medium">God Mode actief</span>
          <span className="text-white/60">in</span>
          <span className="font-mono">{brand.name}</span>
        </div>
        <button
          onClick={exit}
          data-testid="god-mode-exit"
          className="inline-flex items-center gap-1.5 h-7 px-3 rounded-[var(--global-radius)] bg-white text-[#1a1a1a] text-xs font-medium hover:bg-white/90"
        >
          <X className="w-3 h-3" strokeWidth={2.5} /> Exit God Mode
        </button>
      </div>
    </div>
  );
}
